// src/pages/Loyalty.jsx — v12
// CHANGED FROM v11 (31 Jul 2026): added the cashback shipping-exclusion
// disclaimer (parked item from earlier session) — a small info callout
// placed right after the intro paragraph, stating cashback is earned on
// item price only, shipping charges are excluded. No other logic touched.
import React, { useState } from 'react';
import { useStore } from '../context/StoreContext';
import Navbar from '../components/Navbar';
import BottomNav from '../components/BottomNav';
export default function Loyalty() {
  const { user } = useStore();
  const tiers = [
    { name: 'Just Arrived', spend: '₹0 – ₹5,000', rate: '1.0%' },
    { name: 'Getting Comfy', spend: '₹5,000 – ₹15,000', rate: '2.0%' },
    { name: 'Part of the Gang', spend: '₹15,000 – ₹30,000', rate: '5.0%' },
    { name: 'Inner Circle', spend: '₹30,000 – ₹50,000', rate: '7.5%' },
    { name: 'nobrand OG', spend: '₹50,000+', rate: '10.0%' },
  ];
  const TIER_LEVELS = [
    { name: 'Just Arrived', min: 0, rate: 1.0 },
    { name: 'Getting Comfy', min: 5000, rate: 2.0 },
    { name: 'Part of the Gang', min: 15000, rate: 5.0 },
    { name: 'Inner Circle', min: 30000, rate: 7.5 },
    { name: 'nobrand OG', min: 50000, rate: 10.0 },
  ];
  function fmtRupee(n) {
    return '₹' + Math.round(n).toLocaleString('en-IN');
  }
  // v11: yearSpend drives the tier now, not lifetimeSpend.
  const liveSpend = user?.wallet?.yearSpend ?? user?.wallet?.lifetimeSpend;
  let liveTier = null, liveNext = null, liveProgressPct = 0;
  if (liveSpend != null) {
    liveTier = TIER_LEVELS[0];
    for (const t of TIER_LEVELS) {
      if (liveSpend >= t.min) liveTier = t;
    }
    const liveTierIdx = TIER_LEVELS.indexOf(liveTier);
    liveNext = TIER_LEVELS[liveTierIdx + 1];
    const rangeStart = liveTier.min;
    const rangeEnd = liveNext ? liveNext.min : rangeStart + 1;
    liveProgressPct = liveNext ? Math.min(100, Math.max(0, ((liveSpend - rangeStart) / (rangeEnd - rangeStart)) * 100)) : 100;
  }
  return (
    <div className="app-shell">
      <Navbar showBack title="Cashback Program" />
      <div className="page-body" style={{ paddingBottom: 80 }}>
        <h1 style={{ fontSize: 22, fontWeight: 600, marginBottom: 6, color: 'var(--navy)' }}>nb wallet — Cashback Program</h1>
        <p style={{ fontSize: 13, color: '#555', lineHeight: 1.7, marginBottom: 14 }}>
          Every purchase earns you cashback into your nb wallet. The more you shop with us, the higher your tier — and the higher your cashback rate.
        </p>
        {/* NEW (v12): cashback shipping-exclusion disclaimer */}
        <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start', background: '#FEF8E8', borderRadius: 8, padding: '10px 14px', marginBottom: 20, fontSize: 12, color: '#854F0B', lineHeight: 1.6 }}>
          <i className="ti ti-info-circle" style={{ fontSize: 15, flexShrink: 0, marginTop: 1 }}></i>
          <span>Cashback is earned on item price only — shipping charges are excluded.</span>
        </div>
        {liveTier && (
          <div className="loyalty-live-card">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
              <span style={{ fontSize: 15, fontWeight: 600, color: 'var(--navy)' }}>{liveTier.name}</span>
              <span style={{ fontSize: 11, fontWeight: 600, padding: '3px 8px', borderRadius: 5, background: '#E8F5E9', color: 'var(--green)' }}>{liveTier.rate.toFixed(1)}% cashback</span>
            </div>
            <div style={{ height: 6, background: '#F4F2EE', borderRadius: 3, overflow: 'hidden', marginBottom: 6 }}>
              <div style={{ height: '100%', width: `${liveProgressPct}%`, background: 'var(--blue)' }}></div>
            </div>
            <p style={{ fontSize: 11, color: '#888', margin: '0 0 12px' }}>
              {liveNext ? `${fmtRupee(liveNext.min - liveSpend)} more to reach ${liveNext.name} (${liveNext.rate.toFixed(1)}%)` : "You're at our top tier"}
            </p>
            <div style={{ display: 'flex', justifyContent: 'space-between', borderTop: '0.5px solid var(--border)', paddingTop: 10 }}>
              <div>
                <p style={{ fontSize: 10, color: '#888', margin: 0 }}>Wallet balance</p>
                <p style={{ fontSize: 16, fontWeight: 600, color: 'var(--navy)', margin: '2px 0 0' }}>{fmtRupee(user?.wallet?.walletBalance || 0)}</p>
              </div>
              <div style={{ textAlign: 'right' }}>
                <p style={{ fontSize: 10, color: '#888', margin: 0 }}>This year's spend</p>
                <p style={{ fontSize: 16, fontWeight: 600, color: 'var(--navy)', margin: '2px 0 0' }}>{fmtRupee(liveSpend)}</p>
              </div>
            </div>
          </div>
        )}
        <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--navy)', marginBottom: 10 }}>Tiers & Cashback Rate</div>
        <p style={{ fontSize: 12.5, color: '#555', lineHeight: 1.7, marginBottom: 12 }}>
          Your tier is based on your spend within the current calendar year. As your spend crosses each threshold, your cashback rate automatically increases on future orders.
        </p>
        <table className="loyalty-table">
          <thead>
            <tr><th>Tier</th><th>Spend This Year</th><th>Cashback Rate</th></tr>
          </thead>
          <tbody>
            {tiers.map(t => (
              <tr key={t.name}><td>{t.name}</td><td>{t.spend}</td><td style={{ fontWeight: 600, color: 'var(--green)' }}>{t.rate}</td></tr>
            ))}
          </tbody>
        </table>
        <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--navy)', margin: '24px 0 10px' }}>How nb wallet Works</div>
        <ul className="loyalty-list">
          <li>Earn cashback on every completed order, credited to your nb wallet a day after delivery is confirmed (as long as no return is raised)</li>
          <li>Your tier — and cashback rate — is based on your spend, and resets annually on 1st January each year. Your nb wallet balance is not affected by this reset and remains fully intact</li>
          <li>nb wallet credit is valid for 180 days from the date it's added</li>
          <li>Once your balance crosses ₹25, you can use up to 50% of any order's value from your nb wallet — the rest is payable normally. This 50% limit is the same for every tier; tier only affects how fast you earn, not how much you can use</li>
          <li>Only the amount you actually use is deducted — any unused allowance stays in your wallet</li>
          <li>nb wallet credit cannot be transferred back to your bank account once added</li>
        </ul>
        <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--navy)', margin: '24px 0 10px' }}>Returns & nb wallet</div>
        <p style={{ fontSize: 12.5, color: '#555', lineHeight: 1.7 }}>
          If an eligible return is approved, you'll be able to choose between a refund to your original payment method or instant nb wallet credit — see our{' '}
          <a href="/returns" style={{ color: '#2F6FED', fontWeight: 600, textDecoration: 'underline' }}>Return Policy</a> for full details.
        </p>
        <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--navy)', margin: '24px 0 10px' }}>Share & Earn</div>
        <p style={{ fontSize: 12.5, color: '#555', lineHeight: 1.7 }}>
          Available from Part of the Gang tier and above — share our products with your network and keep the margin you set.
        </p>
        <div style={{ background: '#F4F2EE', borderRadius: 8, padding: 14, marginTop: 24, fontSize: 12, color: '#555', lineHeight: 1.7 }}>
          Sign in or create an account to track your tier and nb wallet balance in real time.
        </div>
        <p style={{ fontSize: 11, color: '#999', lineHeight: 1.7, marginTop: 20 }}>
          nobrand store reserves the right to change, replace, modify, or remove any of these terms at any time, without prior notice.
        </p>
      </div>
      <BottomNav />
      <style>{`
        .loyalty-table { width: 100%; border-collapse: collapse; font-size: 12px; }
        .loyalty-table th { background: var(--navy); color: #fff; padding: 8px 10px; text-align: left; font-weight: 500; }
        .loyalty-table td { padding: 8px 10px; border-bottom: 0.5px solid var(--border); color: #555; }
        .loyalty-table tr:nth-child(even) { background: #fafafa; }
        .loyalty-list { padding-left: 18px; font-size: 12.5px; color: #555; line-height: 1.9; }
        .loyalty-live-card { background: #F4F2EE; border-radius: 10px; padding: 14px 16px; margin-bottom: 20px; }
      `}</style>
    </div>
  );
}